import less from 'less';
/*
**************************************************
  Definitions
**************************************************
*/

var Color = less.tree.Color;
var definitions = {
  Color: Color
};
/*
**************************************************
  Functions
**************************************************
*/

var lighten = less.functions.functionRegistry.get('lighten');
var darken = less.functions.functionRegistry.get('darken');
var saturate = less.functions.functionRegistry.get('saturate');
var functions = {
  lighten: lighten,
  darken: darken,
  saturate: saturate
};
export default {
  definitions: definitions,
  functions: functions
};